import React from "react";
import "./About.css";

function About() {
  return (
    <div className="about">
      <h1>Let's talk about Me</h1>

      <h3>
        Hey..! Guys I am Yuvraj a Aspiring full stack developer deep diving into
        the Tech industry ,CS and Engineering Student, Awesome visual designer,
        focused on improving the digital realm. If you're looking for a source
        of design inspiration, you're in the right place. My interest are more
        towards the coding world cause the idea of creating something concrete
        from abstract is just epic. Looking for opportunities to shape myself
        aiming to become better each day. Emphasizing values more than any skill
        .Besides Coding I also write Articles on{" "}
        <a target="_blank" href="https://medium.com">
          Medium
        </a>{" "}
        and Online Mentoring on platforms like discord and slack .Excellent at
        Time management and Strategic Planning Synthetical ,Creative thinking...
        Having dozens of experience in iOS and Web Development under my belt,
        Procifiency with languages like Swift, JavaScript, C/C++, JAVA, Python..
        and technologies like NodeJS, ExpressJS, ReactJS, Sockets, UIKit, Xcode,
        making REST APIs etc. Thanks for the read. Make sure to check out my
        social media
      </h3>
    </div>
  );
}

export default About;
